import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class TermsAndConditions extends Component {
    render() {
        return (
            <div className="ckp-info-page">
                <section className="ckp-info-page-section">
                    <h1 className="ckp-info-page-title u-text-center u-bold">
                        Terms and Conditions- Clear’em BV – June 2, 2022
                    </h1>
                    <p className="ckp-info-page-paragraph u-italic">
                        All use of Clear’em World Wide Web pages located within{' '}
                        <a href="https://clearem.tv">https://clearem.tv</a> is subject to the terms and conditions set
                        forth below (“Terms”), provided however that other terms of use shall apply with respect to
                        Clear’em affiliates’ websites, as specified on each such website. Any use of such web pages
                        constitutes the user’s agreement to abide by the Terms. We may amend the Terms at any time by
                        posting the amended terms on this site.
                    </p>
                </section>
                <section className="ckp-info-page-section">
                    <h2 className="ckp-info-page-subtitle">PRIVACY</h2>
                    <p className="ckp-info-page-paragraph u-margin-bottom-1">
                        Please review our Privacy Policy, which also governs your visit to our website.
                    </p>
                    <p className="ckp-info-page-paragraph">
                        Any personal data that we collect from you when you use this website will be processed in
                        accordance with our Privacy Policy. You confirm that when using this website, you consent to
                        your personal data being used and processed in accordance with our Privacy Policy.
                    </p>
                </section>

                <section className="ckp-info-page-section">
                    <h2 className="ckp-info-page-subtitle">COPYRIGHT AND TRADEMARKS</h2>
                    <p className="ckp-info-page-paragraph u-margin-bottom-1">
                        All content provided on this site together with the website design, text and graphics, and their
                        selection and arrangement, and all software compilations, underlying source code and software
                        (The “Clear’em content”) is owned by or licensed to Clear’em BV and/or its affiliates and
                        protected by Belgian an international copyright laws. Clear’em and its licensors retain all
                        proprietary rights to the Clear’em Content. All rights are reserved. The Clear’em Content may
                        not be reproduced, transmitted or distributed without the prior written consent of Clear’em.
                    </p>
                    <p className="ckp-info-page-paragraph">
                        The trademarks, service marks, trade names and logos on this site are trademarks of Clear’em
                        and/or its affiliates (“Marks”).
                    </p>
                </section>

                <section className="ckp-info-page-section">
                    <h2 className="ckp-info-page-subtitle">CONTENT LIABILITY</h2>
                    <p className="ckp-info-page-paragraph">
                        The Clear’em services are provided “as is” and “as available” without warranties of any kind,
                        either express or implied, including, but not limited to, implied warranties of merchantability,
                        title, and non-infringement.
                    </p>
                    <p className="ckp-info-page-paragraph">
                        Clear’em entities do not warrant that the services are accurate, complete, reliable, current or
                        service free.
                    </p>
                    <p className="ckp-info-page-paragraph">
                        Clear’em does not control, endorse or take responsibility for any content available or linked to
                        the services or the actions of any third party users.
                    </p>
                </section>

                <section className="ckp-info-page-section">
                    <h2 className="ckp-info-page-subtitle">DIGITAL SIGNATURE</h2>
                    <p className="ckp-info-page-paragraph">
                        By accepting these terms and conditions, user of Clear’em accepts the procedure used to sign and
                        formalize contracts via Clear’em. The “I hereby sign and agree with this contract” box is agreed
                        to be a legally binding consent to the contract. User accepts and confirms that the Clear’em
                        procedure guarantees sufficiently the identification of the contractor and the integrity of the
                        contract content, necessary fort he use of a digital signature.
                    </p>
                </section>

                <section className="ckp-info-page-section">
                    <h2 className="ckp-info-page-subtitle">LINKS TO OTHER WEBSITES</h2>
                    <p className="ckp-info-page-paragraph">
                        This website may contain links or references to other websites which are not operated by us.
                        Unless otherwise specified, we do not endorse any of these other websites and expressly
                        disassociate ourselves herewith from all contents of these sites. This declaration applies to
                        all links to external sites covered by us and to all the contents of these sites to which these
                        links lead.
                    </p>
                </section>

                <section className="ckp-info-page-section">
                    <h2 className="ckp-info-page-subtitle">PROHIBITED USE</h2>
                    <p className="ckp-info-page-paragraph u-margin-bottom-1">
                        This site and any portion hereof may not be reproduced, duplicated, copied, downloaded, sold,
                        resold, visited, or otherwise exploited for any commercial purpose without the express written
                        consent of Clear’em. You may not frame or utilize framing techniques to enclose any trademark,
                        logo or other proprietary information (including images, text, page layout and form) of Clear’em
                        and/or its affiliates without the express written consent of Clear’em. You are not permitted to
                        use any mechanisms or scripts that could disrupt or restrict the functionalities of the Clear’em
                        website. You may not take any action which could result in an unreasonable or excessive load on
                        the Clear’em infrastructure.
                    </p>
                    <p className="ckp-info-page-paragraph">
                        You may not block, overwrite or modify any content generated by us or in other way disrupt the
                        website.You may not use any meta tags or any other “hidden text” utilizing Clear’em’s name or
                        Marks without the express written consent of Clear’em. Any unauthorized use terminates the
                        license granted by Clear’em.
                    </p>
                </section>

                <section className="ckp-info-page-section">
                    <h2 className="ckp-info-page-subtitle">TERMINATION</h2>
                    <p className="ckp-info-page-paragraph">
                        Clear’em may terminate your access to this site and the services within it on written notice to
                        you. All disclaimers, indemnities and exclusions in the Terms shall survive termination of the
                        agreement between you and Clear’em for any reason.
                    </p>
                </section>

                <section className="ckp-info-page-section">
                    <h2 className="ckp-info-page-subtitle">CONTACT</h2>
                    <p className="ckp-info-page-paragraph">
                        <address>
                            <p>CLEAR’EM BV</p>
                            <p>GABRIELLELEI 1</p>
                            <p>2930 BRASSCHAAT</p>
                            <p>RLP 735.786.174</p>
                        </address>
                    </p>
                </section>
            </div>
        );
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TermsAndConditions);



// WEBPACK FOOTER //
// ./src/containers/authentication/TermsAndConditions.js